module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-4-1.v1.jpg";